<template>
    <div>
        <loader-component v-if="isSendingDataToServer"></loader-component>
        <loader-component v-if="showLoader"></loader-component>
        <div>
            <!-- responsive-header -->
            <responsive-header-component></responsive-header-component>
            <!-- responsive-header -->

            <div class="wrapper default">

                <!-- header -->
                <header class="main-header default">
                    <div class="container">
                        <header-component></header-component>
                    </div>
                    <navbar-component></navbar-component>
                </header>
                <!-- header -->


                <main class="search-page default">
                    <div class="container">
                        <div class="row">
                            <aside class="sidebar-page col-12 col-sm-12 col-md-4 col-lg-3 order-1 order-xs-1 ">
                                <div class="box">
                                    <div class="box-content active filter-content">
                                        <input @click="resetFilter" class="btn btn-action btn-width red-btn" type="button" value="حذف تمام فیلتر ها " />
                                    </div>
                                </div>
                                <search-in-result></search-in-result>
                                <product-grouping></product-grouping>
                                <product-brands></product-brands>
                                <range-slider></range-slider>
                                <div class="box">
                                    <div class="box-content">
                                        <div class="form-account-agree">
                                            <label class="checkbox-form checkbox-primary">
                                                <input v-model="isAvalible" @change="isAvalibleEvent" type="checkbox">
                                                <span class="checkbox-check"></span>
                                            </label>
                                            <label for="agree-IsAvailable">
                                                فقط کالا های موجود
                                            </label>
                                        </div>
                                    </div>
                                </div>

                            </aside>
                            <div class="col-12 col-sm-12 col-md-8 col-lg-9 order-2 order-xs-2 align-self-md-start" v-if="products.length > 0 || isSendingDataToServer">
                                <breadcrumb></breadcrumb>
                                <div class="listing default">
                                    <div class="listing-counter">{{ filteredCount }} محصول یافته شد</div>
                                    <order-by></order-by>
                                    <filterd-product-viewer></filterd-product-viewer>
                                    <paging></paging>
                                </div>
                            </div>
                            <div class="container text-center col-12 col-sm-12 col-md-8 order-md-2 align-self-md-start" v-else="">
                                <no-result-found></no-result-found>
                            </div>
                 
                        </div>
                        <div class="row" v-if="description != null">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 ">
                                <div class="des-crip-tion">
                                    <div v-html="description">

                                    </div>
                                </div>
                            </div>
                        </div>
               
                        <comments></comments>
         
                    </div>
                </main>

                <footer-component></footer-component>
                <footer-fixnav-component></footer-fixnav-component>
            </div>
        </div>
    </div>
</template>


<script>
    import { filterEventBus } from "../../eventBus/eventBus";
    import { initialSite } from "../../module/initialSite";
    import { httpPromise } from "../../module/httpUtility";
 
    import productBrands from "./productBrands.vue"
    import productGrouping from './productGrouping.vue';
    import noResultFound from './noResultFound.vue';
    import breadcrumb from './breadcrumb.vue'
    import searchInResult from './searchInResult';
    import rangeSlider from './rangeSlider.vue'
    import paging from './paging.vue'
    import orderBy from './orderBy.vue'
    import comments from './comments.vue'
    import filterdProductViewer from "./filterdProductViewer.vue";

    export default {
        data() {
            return {
                searchInResult: '',
                rangeSliderValues: { from: 0, to: 0, min: 0, max: 0 },
                orderBy: 0,
                selectedBrands: [],
                filteredCount: 0,
                products: [],
                isAvalible: false,
                isSendingDataToServer: false,
                showLoader: false,
                description: ''
            }
        },
        components: {
            'no-result-found': noResultFound,
            'breadcrumb': breadcrumb,
            'search-in-result': searchInResult,
            'range-slider': rangeSlider,
            'product-grouping': productGrouping,
            'paging': paging,
            'order-by': orderBy,
            'product-brands': productBrands,
            'filterd-product-viewer': filterdProductViewer,
            'comments': comments
        },
        watch: {
            $route: function (to, from) {
                this.sendToServer();
            },
            '$route.query': {
                immediate: true,
                deep: true,
                handler(newQuery) {
                    // پیدا کردن تگ robots موجود
                    const robotsMeta = $('meta[name="robots"]');

                    const hasSearchValue = Object.prototype.hasOwnProperty.call(newQuery, "SearchValue");
                    const hasTagId = !IsNullOrEmptyString(newQuery.TagId);

                    if (hasSearchValue || hasTagId) {
                        if (robotsMeta.length) {
                            // اگه محتوای قبلی index, follow بود → جایگزین کن
                            if (robotsMeta.attr("content") === "index, follow") {
                                robotsMeta.attr("content", "noindex, follow");
                            } else {
                                robotsMeta.attr("content", "noindex, follow");
                            }
                        } else {
                            // اگه وجود نداشت → اضافه کن
                            $('head').append('<meta name="robots" content="noindex, follow">');
                        }
                    } else {
                        // اگه هیچ شرطی برقرار نبود → متای قبلی رو دست‌نخورده بذار یا حذف کن (اختیاری)
                        if (robotsMeta.length && robotsMeta.attr("content") === "noindex, follow") {
                            robotsMeta.remove();
                        }
                    }
                }
            }

        },
        beforeMount: function () {
          
            initialSite(this);
            this.sendToServer();
        },
        created() {
            filterEventBus.$on('createQueryStringParameter', this.createQueryStringParameter)
        },
        beforeDestroy() {
            filterEventBus.$off('createQueryStringParameter');
        },
        computed: {
            
        },
        methods: {

            isAvalibleEvent() {
                this.createQueryStringParameter();
            },


            createQueryStringParameter(page) {
                var query = {};
                var allowToAppendQueryString = true;

                if (!IsNullOrEmptyString(this.$route.query.GroupId)) {
                    query.GroupId = this.$route.query.GroupId;
                    allowToAppendQueryString = false;
                    if (!IsNullOrEmptyString(this.$route.query.GroupName)) {
                        query.GroupName = this.$route.query.GroupName;
                    }
                } else {
                    if (!IsNullOrEmptyString(this.$route.query.SubGroupId)) {
                        query.SubGroupId = this.$route.query.SubGroupId;
                        allowToAppendQueryString = false;
                        if (!IsNullOrEmptyString(this.$route.query.SubGroupName)) {
                            query.SubGroupName = this.$route.query.SubGroupName;
                        }
                        if (!IsNullOrEmptyString(this.$route.query.CategoryId)) {
                            query.CategoryId = this.$route.query.CategoryId;
                            if (!IsNullOrEmptyString(this.$route.query.CategoryName)) {
                                query.CategoryName = this.$route.query.CategoryName;
                            }
                        }
                    }
                }


                if (allowToAppendQueryString) {
                    if (!IsNullOrEmptyString(this.$route.query.TagId)) {
                        query.TagId = this.$route.query.TagId;
                        allowToAppendQueryString = false;
                        if (!IsNullOrEmptyString(this.$route.query.TagName)) {
                            query.TagName = this.$route.query.TagName;
                        }
                    }
                }
                if (allowToAppendQueryString) {
                    if (!IsNullOrEmptyString(this.$route.query.SearchValue)) {
                        query.SearchValue = this.$route.query.SearchValue;
                        allowToAppendQueryString = false;
                    }
                }
                if (allowToAppendQueryString) {
                    if (!IsNullOrEmptyString(this.$route.query.BrandCode)) {
                        query.BrandCode = this.$route.query.BrandCode;
                        allowToAppendQueryString = false;
                        if (!IsNullOrEmptyString(this.$route.query.BrandName)) {
                            query.BrandName = this.$route.query.BrandName;
                        }
                    }
                }
                if (!IsNullOrEmptyString(this.searchInResult))
                    query.SearchInResult = this.searchInResult;

                if (!IsNullOrEmptyString(this.isAvalible) || this.isAvalible == true)
                    query.IsAvalible = this.isAvalible ? 'true' : '';

                if (!IsNullOrEmptyString(page))
                    query.Page = page;

                if (this.selectedBrands != null && this.selectedBrands.length != 0)
                    query.BrandIds = this.selectedBrands;

                if (this.rangeSliderValues.from != this.rangeSliderValues.min || this.rangeSliderValues.to != this.rangeSliderValues.max) {
                    query.FromPriceRange = this.rangeSliderValues.from;
                    query.ToPriceRange = this.rangeSliderValues.to;
                }

                if (this.orderBy != 0)
                    query.OrderBy = this.orderBy;

                this.$router.push({ name: 'filter', query: query });
            },


            sendToServer() {
                this.isSendingDataToServer = true;
                var data = Object.assign({}, this.$route.query);
                if (data.BrandIds != null)
                    data.BrandIds = data.BrandIds.join();
                httpPromise(this, '/v1/ProductManagement/Filters/Read', 'get', data,
                    response => {
                        this.filteredCount = response.data.Value.TotalCount;
                        this.products = response.data.Value.FilteredProducts;
                        this.isAvalible = this.$route.query.IsAvalible == 'true' ? true : false;
                        filterEventBus.$emit('productViewer', response.data.Value.FilteredProducts);
                        filterEventBus.$emit('initializSearchInResult', this.$route.query.SearchInResult);
                        filterEventBus.$emit('breadcrumbCreator');
                        filterEventBus.$emit('createRangeSlider', response.data.Value.FilteredPriceRange.MinPrice, response.data.Value.FilteredPriceRange.MaxPrice, this.$route.query.FromPriceRange, this.$route.query.ToPriceRange);
                        filterEventBus.$emit('createPaging', response.data.Value.TotalCount, response.data.Value.Page);
                        filterEventBus.$emit('initializOrderBy');
                        filterEventBus.$emit('initializIsAvalible');
                        filterEventBus.$emit('initializBrands', response.data.Value.FilteredBrands);
                        this.description = response.data.Value.MetaTags != null ? response.data.Value.MetaTags.Description : null;
                        $(function () {
                            if (response.data.Value.MetaTags != null) {
                                $('meta[name="description"]').attr("content", response.data.Value.MetaTags.MetaDescription);
                                $('meta[name="keywords"]').attr("content", response.data.Value.MetaTags.KeyWordsMetaTag);
                                //$('link[rel="canonical"]').attr("href", response.data.Value.MetaTags.CanonicalHref);
                                $('meta[property="og:description"]').attr("content", response.data.Value.MetaTags.MetaDescription);
            /*                $('meta[property="og:image"]').attr("content", response.data.Value.PicPath);*/
                             
                            }
                            if (response.data.Value.MetaTags != null) {
                 
                                if (response.data.Value.MetaTags.MetaTitle != null) {
                                    createPageTitle(response.data.Value.MetaTags.MetaTitle);
                                } else {
                                    createPageTitle("تجهیزات صنعتی آشپزخانه نقره ای");
                                }
                            }
                            
                        });
                   
                        this.scrollTop();
                        this.isSendingDataToServer = false;
                    },
                    response => {
                        this.isSendingDataToServer = false;
                    }
                );
            },
            resetFilter() {
                this.$router.replace({ 'query': null });
                this.orderBy = 0;
                this.selectedBrands = [];
                this.searchInResult = '';
                this.isAvalible = false;
                this.rangeSliderValues.min = this.rangeSliderValues.from;
                this.rangeSliderValues.max = this.rangeSliderValues.to;
                filterEventBus.$emit('resetRangeSlider');
                this.createQueryStringParameter();
            },
            scrollTop() {
                $(function () {
                  //  $('html, body').animate({ scrollTop: 0 }, 800, 'easeInExpo');
                });
            }
        }
    }
</script>

<style scoped>
    .des-crip-tion {
        background-color:#fff;
        padding:20px;
        margin-top:15px;
        border-radius:15px;
    }
    ul li a {
        cursor: pointer;
    }

    /*.wrapper-child {
        position: fixed;
        background-color: rgba(140, 130, 128, 0.5) !important;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

        .wrapper-child .div-img {
            background-color: #fff;
        }

        .wrapper-child .div-img-p {
            text-align: center;
        }*/

    .btn-width {
        width: 100%;
    }

    .box-search {
        position: relative;
    }





    .form-account-agree {
        margin: 0;
    }

    .filter-box {
        position: relative;
    }

    .remove-box-filter {
        position: absolute;
        display: inline;
        left: 15px;
        top: 10px;
        cursor: pointer;
    }



    .close {
        cursor: pointer;
        float: left;
        vertical-align: middle !important;
        padding-right: 5px;
        padding-top: 3px;
    }

    .filter-content ul li:hover .close {
        color: #333;
    }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .sidebar-page .box {
            margin: 10px 0 10px;
        }
    }

    @media only screen and (min-width: 641px) and (max-width: 850px) {
        .sidebar-page .box {
            margin: 10px 0 10px;
        }
    }
</style>